import {AsyncPipe} from "@angular/common";
import {Component, HostListener, Input, OnInit, QueryList, ViewChildren,} from '@angular/core';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {AssetService, AssetType, GroupAsset} from '@app/asset';
import {GroupSheetComponent} from '@app/viewer/group-sheet/group-sheet.component';
import {ViewerToolsService} from '@app/viewer/viewer-tools.service';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ImageComponent} from '../image/image.component';
import {MarmosetComponent} from '../marmoset/marmoset.component';
import {VideoComponent} from '../video/video.component';
import {IViewable, ViewerTool} from '../viewable.interface';

@Component({
    selector: 'frog-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss'],
    imports: [ImageComponent, VideoComponent, MarmosetComponent, MatIconButton, MatIcon, AsyncPipe],
})
export class GroupComponent implements OnInit, IViewable {
    @ViewChildren('assetViewer') viewers: QueryList<IViewable>;
    @Input() asset: GroupAsset;
    @Input() preferences: any;

    public index: number;
    public groupAsset$: Observable<GroupAsset>;
    public AssetType = AssetType;

    constructor(
        private viewerToolsService: ViewerToolsService,
        private assetService: AssetService,
        private matBottomSheet: MatBottomSheet,
    ) {
        this.index = 0;
    }

    ngOnInit(): void {
        const viewerTools = [];
        viewerTools.push(
            new ViewerTool({
                icon: 'group_work',
                tooltip: 'Show group contents',
                action: () => {
                    this.openContents();
                },
            }),
        );

        this.viewerToolsService.setTools(viewerTools);


        const groupAsset = this.asset as GroupAsset;
        if (groupAsset.child_ids.length === 0) {
            groupAsset.children = [];
        }

        this.groupAsset$ = this.assetService.resolve(groupAsset.child_ids)
            .pipe(
                map(assets => {
                    groupAsset.children = [];
                    for (const asset of assets) {
                        const index = groupAsset.child_ids.indexOf(asset.id);
                        groupAsset.children[index] = asset;
                    }
                    return groupAsset;
                })
            );
    }

    center(): void {
        this.viewers.forEach((viewer) => viewer.center());
    }

    scaleToSource(): void {
        this.viewers.forEach((viewer) => viewer.scaleToSource());
    }

    scaleToWindow(): void {
        this.viewers.forEach((viewer) => viewer.scaleToWindow());
    }

    @HostListener('document:keydown.e')
    next() {
        let index: number;

        index = this.index + 1;
        index = index > this.asset.children.length - 1 ? 0 : index;

        this.setIndex(index);
    }

    @HostListener('document:keydown.q')
    previous() {
        let index = this.index - 1;
        index = index < 0 ? this.asset.children.length - 1 : index;
        this.setIndex(index);
    }

    setIndex(index: number) {
        this.index = index;
    }

    openContents() {
        const dialog = this.matBottomSheet.open(GroupSheetComponent, {
            data: this.asset.children,
            panelClass: 'group-contents',
        });
        dialog.afterDismissed().subscribe((index) => {
            if (index >= 0) {
                this.setIndex(index);
            }
        });
    }
}
